<template>
  <div class="web-box-all">
    <div class="web-login-header">
      <div class="web-login-header-main">
        <div class="web-login-header-logo">
          <img src="@/assets/icon/logo.png"/>
        </div>
        <div class="web-login-header-info">
          <p>弗兰卡再供应 赋能未来</p>
        </div>
      </div>
    </div>

    <div class="web-login-banner">
      <div class="web-login-banner-img" :style="{ height: main_height+'px'}">
        <img src="@/assets/login_bj.png" :style="{ height: main_height+'px'}">
      </div>
      <div class="web-login-banner-main">

        <div class="app-verify-main">
          <div class="app-verify-title">
              <h2>请完成安全验证</h2>
          </div>
          <iframe class="app-verify-data" style="width:100%; height:100%;  overflow: hidden;overflow-x:hidden;overflow-y:hidden; margin-left:10px;" :src="verify_url"></iframe>
        </div>
        <div class="web-login-form">
          <h2>
            <a class="select">欢迎登录弗兰卡订货网站</a>
          </h2>
          <form>
            <ul>
            <li>
              <p>
              <a>
                <img src="@/assets/icon/login04.png"/>
              </a>
              <b>
                <select id="login_type" @change="get_login_type" class="form-control form-control-sm">
                  <option value="">请选择</option>
                  <option value="1">国际编码（7位数字）</option>
                  <option value="2">门店编号（如:BJ1234）</option>
                </select>
              </b>
              </p>
            </li>
            <li>
            <p>
            <a>
              <img src="@/assets/icon/login01.png"/>
            </a>
            <b>
              <input type="text" id="account" autocomplete @keyup.enter="post_data()" value="" :placeholder="placeholder"/>
            </b>
            </p>
            </li>
            <li>
            <p>
            <a>
              <img src="@/assets/icon/login02.png"/>
            </a>
            <b>
              <input type="password" id="password"  autocomplete @keyup.enter="post_data()" value="" placeholder="请输入密码"/>
            </b>
            </p>
            </li>
            <li>
            <h5>
            <a href="https://parts.franke.cn/store/api/check_html" target="_block" >《用户使用协议》</a>
            </h5>
            <h3>
            <a @click="set_password()">忘记密码？</a>
            </h3>
            </li>
            <li style="margin:0px;">
            <h4 id="post_data" @click="post_data()">登 录</h4>
            </li>
            <li style="margin-top:15px;">
            <h6 @click="post_register()">注 册</h6>
            </li>
            </ul>
          </form>
        </div>

      </div>
    </div>

    <div class="ext-footer-box">

        <div class="ext-footer-main">

            <div class="ext-footer-copy">
                <ul>
                    <li>{{copyright_info}}</li>
                </ul>
                <ul>
                    <li><a href="https://beian.miit.gov.cn/" target="_block">{{company_icp}}</a></li>
                    <li>联系电话：{{company_tel}}<i></i></li>
                </ul>
            </div>

        </div>

    </div>

    <ext-toast :style="toast_state" :toast_text="toast_text"></ext-toast>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import request from '@/utils/request'
import {getUserId, ajax, Encrypt, Decrypt, webUrl} from '@/utils/extend'
import $ from 'jquery'
import Toast from '@/components/toast/index'

export default {
  name: 'login',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-toast': Toast
  },
  data () {
    return {
      title: '登录',
      copyright_info: '',
      company_icp: '',
      company_tel: '',
      placeholder: '门店编号',
      main_height: 0,
      password_state: 1,
      verify_url: 'https://parts.franke.cn/verify.html?t=1',
      toast_state: 'display:none',
      toast_text: ''
    }
  },
  mounted () {
    $('#login_type').val(['2'])

    localStorage.removeItem('accessToken')
    localStorage.removeItem('store_info')

    this.main_height = 600

    this.load_data()
  },
  methods: {
    toast (msg) {
      var that = this
      that.toast_state = 'display:block'
      that.toast_text = msg
      setTimeout(function () {
        that.toast_text = ''
        that.toast_state = 'display:none'
      }, 3000)
    },
    get_login_type (e) {
      if (e.target.value === '1') {
        this.placeholder = '国际编码'
      } else if (e.target.value === '2') {
        this.placeholder = '门店编号'
      } else {
        this.placeholder = '请选择登录方式'
      }
    },
    verify_post (type) {
      if (type === true) {
        $('#post_data').css({'background': '#cccccc'})
      } else {
        $('#post_data').css({'background': '#d81e06'})
      }
    },
    set_password () {
      this.$router.push('/store/password')
    },
    post_register () {
      this.$router.push('/store/register')
    },
    load_data () {
      var that = this
      request({
        url: '/store/api/get_app_copy',
        method: 'post',
        data: {
          uid: '0'
        }
      }).then(ret => {
        if (ret && ret.code === 'success') {
          that.copyright_info = ret.data.copyright_info
          that.company_icp = ret.data.company_icp
          that.company_tel = ret.data.company_tel
        } else {
          that.toast(ret.msg)
        }
      })
    },
    post_data () {
      var that = this
      var logintype = $('#login_type').val()
      var account = $('#account').val()
      var password = $('#password').val()

      if (!logintype) {
        this.toast('请选择一个登录方式')
        return false
      }

      if (!account) {
        this.toast('请输入账号')
        return false
      }
      if (!password) {
        this.toast('请输入密码')
        return false
      }

      this.verify_post(true)

      var passwordState = this.password_state
      that.password_state = passwordState + 1

      request({
        url: '/store/api/login_json',
        method: 'post',
        data: {
          login_type: logintype,
          account: account,
          password: password,
          is_web: 'WEB'
        }
      }).then(ret => {
        that.verify_post(false)
        if (ret && ret.code === 'success') {
          localStorage.setItem('store_info', JSON.stringify({
            'token': ret.data.token,
            'account': ret.data.id,
            'company_no': ret.data.company_no,
            'login_type': logintype
          }))

          that.toast(ret.msg)
          setTimeout(function () {
            that.$router.push('/')
          }, 1500)
        } else {
          if (that.password_state > 3) {
            that.password_state = 1
            that.verify_url = 'https://parts.franke.cn/verify.html?t=' + Number(new Date())
            $('.app-verify-main').show()
          }
          that.toast(ret.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    display: inline-flex;
    font-family: "Noto Sans SC";
    list-style: none;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}

.web-login-header { width:100%; height:100px;}
  .web-login-header-main { width:1000px; height:100px; margin:0px auto; flex-flow:row; justify-content:space-between;}
    .web-login-header-logo { width:auto; height:70px; margin-top:15px;}
      .web-login-header-logo img { width:auto; height:70px;}
    .web-login-header-info { width:auto; height:100px;}
      .web-login-header-info p { width:auto; height:30px; line-height: 30px; font-size:16px; color:#666666; margin-top:45px;}

.ext-footer-box { width:100%; height:110px; background: #ffffff;}
.ext-footer-main { width:1000px; height:auto; margin:0px auto; background: #ffffff; flex-wrap:wrap; align-content:flex-start;}
    .ext-footer-link { width:100%; height:30px; padding:0px 30px; margin-top:10px; }
        .ext-footer-link p { width:100%; height:40px; line-height:40px; margin:0px; flex-flow:row; justify-content:center;align-content:center;}
        .ext-footer-link p a { width:auto; height:40px; cursor: pointer; position: relative; line-height:40px; padding:0px 10px; font-size:12px; color:#666666;}
        .ext-footer-link p a i { width:1px; height:12px; position:absolute; top:15px; left:0px; border-right: 1px solid #cccccc; }
        .ext-footer-link p a:hover  { color:#d81e06;}
    .ext-footer-copy { width:100%; height:20px;margin-top:20px;flex-wrap:wrap; align-content:flex-start;}
        .ext-footer-copy ul { width:100%; height:24px; list-style: none; line-height:24px; flex-flow:row; justify-content:center; margin:0px;}
        .ext-footer-copy ul li { width:auto; height:24px; font-weight: normal; position: relative; line-height:24px; padding:0px 10px; font-size:12px; color:#666666;}
        .ext-footer-copy ul li i { width:1px; height:12px; position:absolute; top:3px; left:0px; border-right: 1px solid #cccccc; }
        .ext-footer-copy ul li a { color:#666666; cursor: pointer;}
        .ext-footer-copy ul li a:hover  { color:#d81e06;}

.web-login-banner { width:100%; height:475px;
min-height:615px;
width: 100%;
background-repeat: no-repeat;
background-position: 50%;
background-size: 90%;
height: 615px;
overflow: hidden;

}
  .web-login-banner-main { width:1000px; height:auto; margin:0px auto; position: relative;}
  .web-login-form { width:350px; height:460px; position:absolute; flex-wrap:wrap; align-content:flex-start; top:35px; right:0px; background: #ffffff;}
    .web-login-form h2 { width:100%; height:55px; margin-top:0px; border-bottom: 1px solid #f4f4f4;}
    .web-login-form h2 a { width:100%; height:50px; text-align: center; justify-content:center; line-height:50px; font-size:18px; color:#333333;}
    .web-login-form h2 a.select { color:#d81e06; font-weight: bold;}
    .web-login-form ul { width:100%; height:auto; padding:0px 20px; margin-top:10px; flex-wrap:wrap; align-content:flex-start;}
    .web-login-form ul li { width:100%; height:45px; margin-top:20px;}
    .web-login-form ul li p { width:100%; height:45px; overflow: hidden; border: 1px solid #bdbdbd; border-radius: 4px; flex-flow:row; justify-content:flex-start; }
    .web-login-form ul li p a { width:40px; height:45px;}
    .web-login-form ul li p a img { width:16px; height:16px; margin:14px 0px 0px 12px;}
    .web-login-form ul li p b { width:268px; height:45px;}
    .web-login-form ul li p b input { width:240px; height:30px; margin-top:5px; border:0px; min-height:30px; margin-left:0px; font-size:14px; line-height: 30px; color:#333333;}
    .web-login-form ul li p b select { border:0px; font-size:14px;border:none;outline:0;outline:none !important; margin-top:5px; margin-left:-6px; box-sizing:border-box;}
    .web-login-form ul li p b select:focus{border-color:#fff; -webkit-box-shadow:none; box-shadow:none;}
    .web-login-form ul li h3 { width:50%; height:20px; justify-content:flex-end;}
    .web-login-form ul li h3 a { width:100px; height:20px; cursor: pointer; line-height:20px; text-align: right; justify-content:flex-end; font-size:12px; color:#333333;}

    .web-login-form ul li h4 { width:100%; height:45px; cursor: pointer; line-height:45px; font-size:18px; background: #d81e06; color:#ffffff; border-radius: 4px; text-align: center; justify-content:center; }
    .web-login-form ul li h6 { width:100%; height:45px; cursor: pointer; line-height:45px; font-size:18px; background: #efefef; color:#333333; border:1px solid #cccccc; border-radius: 4px; text-align: center; justify-content:center; }
    .web-login-form ul li h5 { width:50%; height:45px; cursor: pointer; line-height:45px; font-size:12px; color:#333333; }
    .web-login-form ul li h5 a { width:100px; height:20px; cursor: pointer; line-height:20px; text-align: left;  font-size:12px; color:#333333; font-weight: bold;}

  .web-login-banner-img { width:100%; height:100px; position:absolute; top:100px; left:0px;}
  .web-login-banner-img img { width:100%; height:100%;object-fit: cover;}

        .app-verify-main { width:310px; height:288px; overflow: hidden; display: none; float:left;flex-wrap:wrap; align-content:flex-start;  border:1px solid #dfdfdf; border-radius: 5px; background: #ffffff; position: absolute; right:20px; top:125px; margin-left:-150px; z-index: 999999;}
        .app-verify-title { width:100%; height:40px; float:left;}
        .app-verify-title h2 { width:100%;  height:30px; line-height:50px; font-size:15px; font-weight: bold; margin:0px; padding:0px 20px; color:#333333;}
        .app-verify-data { width:100%; height:auto; float:left;}
</style>



// WEBPACK FOOTER //
// src/pages/home/login.vue